import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Sparkles, X } from "lucide-react";
import { festivalShort } from "./festivals";

// Subtle dismissible countdown ribbon shown in the days leading up to a festival.
export function FestivalTeaser({ festival, days }) {
  const key = `ito-teaser-dismissed-${festival.key}`;
  const [show, setShow] = useState(() => {
    try {
      return sessionStorage.getItem(key) !== "1";
    } catch {
      return true;
    }
  });
  const accent = festival.accent || "#C84B31";
  const label = festivalShort(festival);
  const when = days === 1 ? "tomorrow" : `in ${days} days`;

  const dismiss = () => {
    setShow(false);
    try {
      sessionStorage.setItem(key, "1");
    } catch {
      /* ignore */
    }
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="festival-teaser"
          data-festival={festival.key}
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 24 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-5 left-1/2 -translate-x-1/2 z-[70] max-w-[92vw]"
        >
          <div
            className="flex items-center gap-3 rounded-full border border-white/15 bg-[#1A1A18]/90 backdrop-blur-md pl-4 pr-2.5 py-2 shadow-2xl"
            style={{ boxShadow: `0 10px 40px -12px ${accent}66` }}
          >
            <span
              className="inline-flex items-center justify-center w-7 h-7 rounded-full shrink-0"
              style={{ backgroundColor: accent }}
            >
              <Sparkles className="w-3.5 h-3.5 text-white" />
            </span>
            <span className="text-sm text-white whitespace-nowrap">
              <span className="font-heading font-bold" style={{ color: accent }}>
                {label}
              </span>{" "}
              greetings go live{" "}
              <span className="font-semibold">{when}</span>
            </span>
            <button
              onClick={dismiss}
              data-testid="festival-teaser-close"
              aria-label="Dismiss"
              className="ml-1 inline-flex items-center justify-center w-6 h-6 rounded-full text-white/60 hover:text-white hover:bg-white/10 transition-colors shrink-0"
            >
              <X className="w-3.5 h-3.5" />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
